import * as angular from 'angular';

import { ComponentDefinition } from '@models/index';

class LogbookBadgeController implements angular.IComponentController {
    readonly hasManualInputRole: boolean; // assumed
    readonly isDirty: boolean; // assumed
    readonly onBadgeClick: (value: { value: any; $event: angular.IAngularEvent; edit: boolean }) => void;
    readonly value; // Type to be determined

    static $inject = [];
   
    badgeClick(value, $event: angular.IAngularEvent, edit: boolean) {
        if (this.onBadgeClick) {
            this.onBadgeClick({ value, $event, edit });
        }
    }
}

export const wtLogbookBadge: ComponentDefinition = {
    componentId: 'wtLogbookBadge',
    controller: LogbookBadgeController,
    template: require('./logbookBadge.component.html'),
    controllerAs: 'vm',
    bindings: {
        hasManualInputRole: '<',
        isDirty: '<',
        onBadgeClick: '&?',
        value: '<'
    }
};
